import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { QUERY_KEY } from './useFilesList.query';

export const useFileCancelQuery = (fileId: string) => {
  const queryClient = useQueryClient();

  const { mutateAsync, isSuccess, isLoading } = useMutation(
    () => api.patch(API_URL.FILE_CANCEL_BY_FILE_ID(fileId), undefined),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY],
        });
      },
    }
  );

  return {
    handleCancel: mutateAsync,
    isSuccess,
    isLoading,
  };
};

export default useFileCancelQuery;
